<template>
  <div class="content_two">
      <div class="box_bgc">
          <div class="label1" @click="active_show(1)">
              <div v-if="active==1" class="selected">全部</div>
              <div v-else class="unselected" @click="getKnapsack()">全部</div>
          </div>
          <div class="label2" @click="active_show(2)">
              <div v-if="active==2" class="selected">功能书</div>
              <div v-else class="unselected" @click="getKnapsack(1)">功能书</div>
          </div>
           <div class="label3" @click="active_show(3)">
              <div v-if="active==3" class="selected">符文</div>
              <div v-else class="unselected" @click="getKnapsack(2)">符文</div>
          </div>
          <div class="label4" @click="active_show(4)">
              <div v-if="active==4" class="selected">饲料</div>
              <div v-else class="unselected" @click="getKnapsack(3)">饲料</div>
          </div>
           <div class="label5" @click="active_show(5)">
              <div v-if="active==5" class="selected">其他</div>
              <div v-else class="unselected" @click="getKnapsack(4)">其他</div>
          </div>
          <div class="left">
              <div class="goods_box">
                  <ul>
                      <li v-for="(item,index) in allGoods" :key="index">
                          <div class="li_div" v-for="it in item.goods" :key="it.prop_id"  @click="look_info(it.prop_id)">
                                <img :src="it.prop_image" alt="" class="goods_item">
                                <span class="goods_num">{{it.num}}</span>
                                <div class="select_box" v-if="checkboxs">
                                        <img v-if="it.is_select" src="../assets/images/yes_all.png" alt="" @click="it.is_select=!it.is_select" @click.stop="discard_list(it.prop_id)" class="select_all">
                                        <img v-else src="../assets/images/no_all.png" alt="" @click="it.is_select=!it.is_select" @click.stop="discard_list(it.prop_id)" class="select_all">
                                        <!-- it.is_select=!it.is_select -->
                                </div>
                          </div>
                      </li>
                  </ul>
              </div>
              <img v-if="checkboxs==false" src="../assets/images/clear_up.png" class="clear_up" @click="checkbox" alt="">
              <img v-else src="../assets/images/batch_discard.png" class="clear_up" @click="discard_goods(2)" alt="">
          </div>
          <div class="right">
             <div v-for="item in goods" :key="item.prop_id" v-if="item.prop_id==prop_id">
                     <div class="liquid_medicine">
                        <div class="liquid_medicine_bgc">
                            <img :src="item.prop_image" alt="">
                        </div>
                        <div class="name">{{item.prop_name}}</div>
                        <div class="decorate"></div>
                        <div class="amount">数量：{{item.num}}</div>
                        <!-- <div class="exp">经验值：{{prop_des}}</div> -->
                    </div>
                    <div class="liquid_medicine_info_box">
                        功能：{{item.prop_desc}}
                    </div>
                    <div class="btns">
                        <div class="btn use" @click="useProps"></div>
                        <div class="btn discard" @click="discard_goods(1)"></div>
                    </div>
             </div>
          </div>
          <img src="../assets/images/close.png" class="close" alt="" @click="gohome">
      </div>
       <div class="shade" v-if="show_shade">
                <div class="edit_pet_name" v-if="show_edit_pet_name">
                    <input type="text" v-model="new_name" class="new_name" maxlength="6">
                    <span class="lable">新名字：</span>
                    <img src="../assets/images/submit_topic.png" class="confrig_name" alt="" @click="edit_pet_info">
                </div>
        </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            active:1,
            //批量选择
            checkboxs:false,
            //是否选中
            select:false,
            //所有物品
            allGoods:[],
            //物品详情
            goods:[],
            //物品id
            prop_id:'',
            //批量丢弃物品id
            prop_ids:[],
            //宠物id
            pet_id:'',
            //宠物的新名字
            new_name:'',
            //宠物的新性格
            new_character:'',
            //显示改名框
            show_edit_pet_name:false,
            //显示遮罩
            show_shade:false
        }
    },
    created(){
        this.getKnapsack();
        this.pet_id = this.$route.params.pet_id
    },
    methods:{
        //多选
        checkbox(num){
            // if(num==1){
                this.checkboxs=true
            // }else {
            //     this.checkboxs=false
            // }
        },
        gohome(){
            this.$router.replace('/home')
        },
        active_show(num){
            if(this.active==num) return;
            this.active=num
        },
        //获取背包信息
        getKnapsack(prop_type){
            this.allGoods=[];
            if(!prop_type){
                prop_type=''
            }
            this.$axios.get(
                '/api/v1/user/bag',
                {
                    params:{
                        prop_type:prop_type
                    }
                }
            ).then(res=>{
                // console.log(res);
                this.goods=res.data.data
                for (var i = 0; i<48; i++) {
                    this.allGoods.push({goods:[]})
                }
                this.allGoods.forEach((item,index)=>{
                    res.data.data.forEach((it,i) => {
                        if(index==i){
                            item.goods.push(it)
                        }else {
                            item.goods.push()
                        }
                    });
                })
            })
        },
        //查看物品详情
        look_info(id){
            // if(this.checkboxs){
            //     this.prop_ids.push(id)
            // }else{
                this.prop_id=id
            // }
            
        },
        //批量丢弃
        discard_list(id){
            console.log(id);
            this.prop_ids.push(id)
        },
        //使用道具
        useProps(){
            if(this.prop_id==11){
                this.show_shade=true
                this.show_edit_pet_name=true
            }
            this.$axios.post(
                '/api/v1/user/playprop',
                {
                    prop_id: this.prop_id,
                    // pet_id: this.pet_id
                }
            ).then(res=>{
                if(res.data.result_code==200){
                    this.$msg.success(res.data.data)
                    this.getKnapsack();
                    if(this.prop_id==10){
                        this.edit_pet_info(Math.floor(Math.random() * (15 - 1) + 1))
                    }
                }else {
                    this.$msg.error('使用道具失败，请稍后重试！')
                }
            })
        },
        //修改宠物信息
        edit_pet_info(new_character){
            this.$axios.post(
                '/api/v1/user/savepet',
                {
                    pet_name: this.new_name,
                    character: new_character,
                }
            ).then(res=>{
                if(res.data.result_code==200){
                    this.$msg.success(res.data.message)
                    this.show_shade=false
                    this.show_edit_pet_name=false
                }else {
                    this.$msg.error(res.data.message)
                }
            })
        },
        //丢弃物品
        discard_goods(type){
            // let ids=[...new set(this.prop_ids)]
            var prop_id=''
            if(type==1){
                prop_id=this.prop_id
            }else {
                let ids=[...new Set(this.prop_ids)]
                prop_id=ids
            }
            this.$axios.post(
                '/api/v1/user/delprop',
                {
                    prop_id
                }
            ).then(res=>{
                if(res.data.result_code==200){
                    this.$msg.success(res.data.message)
                    this.getKnapsack();
                }else {
                    this.$msg.error(res.data.message)
                }
            })
        },

    },
    mounted(){},
}
</script>

<style scoped>
::-webkit-scrollbar {
    width: 0.04rem !important;
    height: 0.266667rem;
}
.box_bgc {
    width: 7.96rem;
    height: 4.36rem;
    background: url('../assets/images/knaspsack_bgc.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    font-family: 'Normal';
}
.close {
    width: 0.65rem;
    height: 0.65rem;
    position: absolute;
    top: 0;
    right: 0;
}
.left {
    width: 3.4rem;
    height: 80%;
    position: absolute;
    top: 0.46rem;
    left: 1.06rem;
}
.goods_box {
    width: 3.4rem;
    height: 3.12rem;
    background: url('../assets/images/goods_box.png') no-repeat;
    background-size: 100% 100%;
}
.clear_up {
    width: 0.86rem;
    height: 0.32rem;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%,0);
    cursor: pointer;
}
.goods_box ul {
    width: 87%;
    height: 82%;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    overflow-y: auto;
}
/* ul::-webkit-scrollbar{
    display:none;
} */
.goods_box ul li {
    width: 0.72rem;
    height: 0.72rem;
    background: url('../assets/images/goods_td_bgc.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
}
.select_box {
    width: 0.19rem;
    height: 0.19rem;
    position: absolute;
    top: 0;
    right: 0;
}
.goods_item {
    width: 0.46rem;
    height: 0.45rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.li_div {
    width: 100%;
    height: 100%;
    position: relative;
}
.goods_num {
    position: absolute;
    bottom: 0.07rem;
    right: 0.05rem;
    font-size: 0.14rem;
    font-family: 'Normal';
    color: #fff;
}
.goods_box ul li .select_all {
    width: 100%;
    height: 100%;
}
.right {
    width: 3rem;
    height: 77%;
    position: absolute;
    top: 0.6rem;
    right: 0.4rem;
    box-sizing: border-box;
    padding: 0 0.25rem;
}
.liquid_medicine {
    height: 0.63rem;
}
.liquid_medicine_bgc {
    display: inline-block;
    width: 0.63rem;
    height: 0.63rem;
    background: url('../assets/images/liquid_medicine_bgc.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
}
.liquid_medicine_bgc img {
    width: 0.46rem;
    height: 0.45rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.name,
.decorate,
.amount,
.exp {
    display: inline-block;
}
.name {
    width: 0.8rem;
    /* height: 0.15rem; */
    position: absolute;
    top: -0.03rem;
    right: 0.94rem;
    font-size: 0.16rem;
    font-family: 'Medium';
    font-weight: 500;
    color: #FFC000;
    text-align: center;
}
.decorate {
    width: 1.09rem;
    height: 0.11rem;
    background: url('../assets/images/decorate.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 0.18rem;
    right: 0.8rem;
}
.amount {
    position: absolute;
    top: 0.25rem;
    right: 1.2rem;
    font-size: 0.14rem;
    font-family: 'Normal';
    color: #4A1414;
}
.exp {
    position: absolute;
    top: 0.45rem;
    right: 0.9rem;
    font-size: 0.14rem;
    font-family: 'Normal';
    color: #4A1414;
}
.liquid_medicine_info_box {
    width: 2.43rem;
    height: 1.76rem;
    background: url('../assets/images/liquid_medicine_info_bgc.png') no-repeat;
    background-size: 100% 100%;
    margin-top: 0.27rem;
    box-sizing: border-box;
    padding: 0.13rem 0.17rem;
    font-size: 0.14rem;
    font-family: 'Normal';
    color: #4A1414;
}
.btns {
    width: 100%;
    height: 0.33rem;
    display: flex;
    justify-content: space-around;
    margin-top: 0.21rem;
    cursor: pointer;
}
.btns .btn {
    width: 0.81rem;
    height: 0.33rem;
} 
.use {
    background: url('../assets/images/use.png') no-repeat;
    background-size: 100% 100%;
}
.discard {
    background: url('../assets/images/discard.png') no-repeat;
    background-size: 100% 100%;
}
.selected {
    width: 0.91rem;
    height: 0.41rem;
    background: url('../assets/images/red_label.png') no-repeat;
    background-size: 100% 100%;
    font-size: 0.17rem;
    font-family: 'Normal';
    color: #564205;
    text-align: center;
    line-height: 0.35rem;
    cursor: pointer;
}
.unselected {
    width: 0.81rem;
    height: 0.38rem;
    background: url('../assets/images/label.png') no-repeat;
    background-size: 100% 100%;
    font-size: 0.17rem;
    font-family: 'Normal';
    color: #564205;
    text-align: center;
    line-height: 0.3rem;
    cursor: pointer;
}
.label1 div {
    position: absolute;
    top: 1.29rem;
    left: 0.18rem;
}
.label2 div {
    position: absolute;
    top: 1.74rem;
    left: 0.18rem;
} 
.label3 div {
    position: absolute;
    top: 2.16rem;
    left: 0.18rem;
} 
.label4 div {
    position: absolute;
    top: 2.58rem;
    left: 0.18rem;
} 
.label5 div {
    position: absolute;
    top: 2.99rem;
    left: 0.18rem;
} 
.edit_pet_name {
    width: 2.82rem;
    height: 1.94rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: url('../assets/images/warn_bgc.png') no-repeat;
    background-size: 100% 100%;
}
.new_name {
    position: absolute;
    top: 0.5rem;
    left: 50%;
    transform: translate(-50%,0);
}
.lable {
    position: absolute;
    top: 0.58rem;
    left: 50%;
    transform: translate(-133%,0);
    font-size: 0.17rem;
    font-family: 'Normal';
    color: #FFFFFF;
}
input {
  width: 2rem;
  height: 0.4rem;
  background-color: #BF6004;
  border-radius: 0.2rem;
  border: none !important;
  font-size: 0.17rem;
  font-family: 'Normal';
  color: #fff;
  box-sizing: border-box;
  padding-left: 0.86rem;
  line-height: 0.4rem;
}
input:focus-visible {
    outline: none;
}
input::placeholder {
  color: #A45A12;
  line-height: 0.4rem;
}
.shade {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: rgba(0, 0, 0, .5);
}
.confrig_name {
    width: 0.92rem;
    height: 0.4rem;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%,0);
}
</style>